import React from 'react';
import { BookmarkIcon, DownloadIcon, SparklesIcon } from 'lucide-react';
interface AlgaCoffeeSummaryWidgetProps {
  coffeeTitle: string;
  coffeeHost: string;
  coffeeTopics: string[];
}
const AlgaCoffeeSummaryWidget: React.FC<AlgaCoffeeSummaryWidgetProps> = ({
  coffeeTitle,
  coffeeHost,
  coffeeTopics
}) => {
  return <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-610">
      <div className="p-4 border-b border-gray-200 flex items-center" data-id="element-611">
        <div className="w-8 h-8 rounded-full bg-gradient-to-br from-custom-green to-emerald-600 flex items-center justify-center mr-3 shadow-sm" data-id="element-612">
          <SparklesIcon size={16} className="text-white" data-id="element-613" />
        </div>
        <div data-id="element-614">
          <h2 className="text-base font-semibold text-gray-800" data-id="element-615">
            Sintesi dell'evento
          </h2>
          <p className="text-xs text-gray-500" data-id="element-616">Powered by Greenback AI</p>
        </div>
      </div>
      <div className="p-4" data-id="element-617">
        <div className="space-y-4" data-id="element-618">
          <div className="flex items-center justify-between" data-id="element-619">
            <h4 className="text-sm font-medium text-gray-800" data-id="element-620">
              Punti chiave discussi
            </h4>
            <div className="flex items-center space-x-2" data-id="element-621">
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-622">
                <BookmarkIcon size={16} className="text-gray-500" data-id="element-623" />
              </button>
              <button className="p-1 rounded-full hover:bg-gray-100" data-id="element-624">
                <DownloadIcon size={16} className="text-gray-500" data-id="element-625" />
              </button>
            </div>
          </div>
          <div className="text-sm text-gray-600" data-id="element-626">
            <ul className="list-disc pl-5 space-y-1" data-id="element-627">
              <li data-id="element-628">
                L'importanza di integrare strategie ESG nel core business
                aziendale
              </li>
              <li data-id="element-629">Come misurare l'impatto delle iniziative di sostenibilità</li>
              <li data-id="element-630">
                Sfide e opportunità nella transizione verso modelli di business
                più sostenibili
              </li>
              <li data-id="element-631">Best practices per il reporting di sostenibilità</li>
            </ul>
            <p className="mt-3" data-id="element-632">
              Durante l'evento, {coffeeHost} ha condiviso esperienze pratiche su
              come implementare strategie ESG efficaci, con particolare
              attenzione ai settori {coffeeTopics.join(', ')}.
            </p>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaCoffeeSummaryWidget;